import { Checkbox } from 'antd'
import PropTypes from 'prop-types'
import { useGetNewspapers } from 'domains/Newspaper/hooks'
import { useSubfilterActions } from 'hooks'
import { StyledDetails } from '../PointsHistoryFilter.styles'
import { useTranslations } from 'contexts/Translation'
import { Text } from '@qonsoll/react-design'

const NewspaperFilter = ({ filterData, setFilterData }) => {
  // [ADDITIONAL_HOOKS]
  const [newspapers] = useGetNewspapers()
  const { t } = useTranslations()

  // [COMPUTED_PROPERTIES]
  const summaryStyles = { marginBottom: '8px' }

  const { onToggleDetails, onChange, checkIsEnabled } = useSubfilterActions({
    filterData,
    setFilterData,
    fieldName: 'newspaper',
    operand: '=='
  })

  return (
    <StyledDetails
      open={localStorage.getItem(`newspaper-details-visibility`) === 'opened'}>
      <summary
        style={summaryStyles}
        onClick={() => onToggleDetails('newspaper')}>
        {t('Newspaper')}
      </summary>
      {newspapers?.map((newspaper, index) => (
        <div key={`status-${index}`}>
          <Checkbox
            key={`status-${index}`}
            checked={checkIsEnabled(newspaper)}
            onChange={() => onChange(newspaper)}>
            <Text wordBreak="break-all">
              {newspaper?.name || t('Unnamed filter')}
            </Text>
          </Checkbox>
        </div>
      ))}
    </StyledDetails>
  )
}

NewspaperFilter.propTypes = {
  filterData: PropTypes.object,
  setFilterData: PropTypes.func
}

export default NewspaperFilter
